module.exports = __webpack_public_path__ + "img/ep-rectangle-4angles-arrondis.c93bf4f0.jpg";